import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
import AnnualReportCtaStyles from './AnnualReportCta/AnnualReportCta.styles';
import FooterLinksStyles from './FooterLinks/FooterLinks.styles';
import LegalLinksStyles from './LegalLinks/LegalLinks.styles';
import SocialLinksStyles from './SocialLinks/SocialLinks.styles';
const Container = styled.section `
  --bgColor: ${brand.grey.grey6};
  --fgColor: ${brand.white};

  position: relative;
  background: var(--bgColor);
  color: var(--fgColor);
  overflow: hidden;
  overflow: clip;

  ${AnnualReportCtaStyles.Container} {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      grid-column: -4 / span 3;
      grid-row: 1;
    }
  }

  ${LegalLinksStyles.Container} {
    grid-column: 1 / span 12;
    margin: 32px 0;

    @media ${from(Device.TabletLarge)} {
      align-self: center;
      grid-column: 1 / span 9;
      grid-row: 3;
      margin: 120px 0 60px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        border-top: 1px solid ${brand.grey.grey3};
        transform: translateY(-60px);
        width: 300vw;
      }
    }
  }

  ${SocialLinksStyles.Container} {
    grid-column: 1 / span 12;

    @media ${from(Device.TabletLarge)} {
      align-self: center;
      grid-column: -4 / span 3;
      grid-row: 2;
    }
  }
`;
const Inner = styled.div `
  ${siteWide};
  ${baseGrid};

  @media ${until(Device.TabletLarge)} {
    padding-top: 24px;
  }

  @media ${from(Device.TabletLarge)} {
    padding-top: 96px;
  }
`;
const LogoWrapper = styled.div `
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 12;
  margin-bottom: 36px;

  @media ${from(Device.MobileLarge)} {
    flex-direction: column;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 3;
    grid-row: 1;
  }
`;
const LogoLink = styled.a `
  display: inline-block;
  color: currentColor;
  flex: 1 1 auto;
  max-height: 142px;

  @media ${until(Device.MobileLarge)} {
    &:first-child {
      margin-right: 6px;
    }

    &:last-child {
      margin-left: 6px;
    }
  }

  @media ${from(Device.MobileLarge)} {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }
`;
const LogoImage = styled(SimpleImage) `
  display: block;
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  object-position: left;
`;
const LinksWrapper = styled.div `
  column-gap: 10px;
  grid-column: 1 / span 12;
  margin-bottom: 32px;

  @media ${from(Device.MobileLarge)} {
    ${baseGrid};

    ${FooterLinksStyles.Container} {
      grid-column: span 6;
    }

    ${Container}[data-links="3"] & {
      ${FooterLinksStyles.Container} {
        grid-column: span 4;
      }
    }
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 4 / span 4;
    grid-row: 1;

    ${Container}[data-links="3"] & {
      grid-column: 4 / span 6;
    }
  }
`;
const SmallText = styled.small `
  color: ${brand.grey.otherGrey};
  ${fonts.helvetica.regular};
  font-size: 12px;
  letter-spacing: -0.01em;
  line-height: 24px;
  opacity: 0.75;
`;
const LegalStatement = styled(SmallText) `
  @media ${until(Device.TabletLarge)} {
    border-bottom: 1px solid ${brand.grey.grey3};
    grid-column: 1 / span 12;
    margin-left: calc(${cssVar('sitePadding')} * -1);
    margin-right: calc(${cssVar('sitePadding')} * -1);
    padding: 0 ${cssVar('sitePadding')} 24px;
  }

  @media ${from(Device.TabletLarge)} {
    align-self: center;
    grid-column: 1 / span 9;
    grid-row: 2;
    max-width: 257px;
  }
`;
const Copyright = styled(SmallText) `
  @media ${until(Device.TabletLarge)} {
    border-top: 1px solid ${brand.grey.grey3};
    grid-column: 1 / span 12;
    margin-left: calc(${cssVar('sitePadding')} * -1);
    margin-right: calc(${cssVar('sitePadding')} * -1);
    padding: 24px ${cssVar('sitePadding')};
  }

  @media ${from(Device.TabletLarge)} {
    align-self: center;
    grid-column: -4 / span 3;
    grid-row: 3;
    margin: 120px 0 60px;
  }
`;
const FooterStyles = {
    Container,
    Copyright,
    Inner,
    LegalStatement,
    LinksWrapper,
    LogoImage,
    LogoLink,
    LogoWrapper,
};
export default FooterStyles;
